import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import style from "./LabelledStockList.module.css";

export default function LabelledStockList({
  columns,
  allCategories,
  handleEditData,
  handlePrint,
  title,
  searchInput,
  setSearchInput,
  usedFor = "",
  showActionButton = true,
  showSum = false,
  sum = {},
  disableHead = false,
  setSelectedAll,
  disablePagination,
  totalData,
  PageNumber,
  PageSize
}) {

  const thStyle = {
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
    backgroundColor: "#627383",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "500",
    minWidth: "fit-content",
  };

  const tdStyle = {
    fontSize: "12px",
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
  };

  const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

 
  const filteredData = searchInput
    ? allCategories?.filter((item) =>
        Object.values(item)?.some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : allCategories;

  const totalPages = Math.ceil(filteredData?.length / rowsPerPages);
  const startIndex = (currentPage - 1) * rowsPerPages;
  const displayedData = filteredData?.slice(
    startIndex,
    startIndex + rowsPerPages
  );

  const preprocessedData = displayedData?.map((product, idx) => ({
    ...product,
    Id: product.Id !== undefined ? product.Id : `temp-id-${idx}`,
    serialNumber: startIndex + idx + 1, // Serial number
  }));


  useEffect(()=>{
    if(preprocessedData?.length && selectedItems?.length){
      const filtered = []
      selectedItems?.forEach((item)=>{
             let found = preprocessedData?.find((pItem)=>pItem?.Id == item)
             if(found){
              filtered.push(found)
             }
      })
      setSelectedAll(filtered)
    }else{
      setSelectedAll([])
    }
   },[selectedItems])

   
  const handlePageClick = (page) => {
    if (page <= totalPages && page >= 1) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  // Smart Pagination Logic
  const generatePagination = () => {
    let pages = [];
    let maxPagesToShow = 0;

    if (totalPages <= maxPagesToShow) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      pages.push(1);

      if (currentPage > 5) {
        pages.push("...");
      }

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };


  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    setSelectedItems(
      e.target.checked ? preprocessedData.map((item) => item.Id) : []
    );
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  // const handlePrintAll = ()=>{
  //   console.log(selectedItems)
  // }
  return (
    <>
      <div className={style["table-container"]}>
        <table className={style["custom-table"]}>
          <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
            <tr>
              {columns?.map((column) => (
                <th key={column.key} style={thStyle}>
                  {column.label}
                </th>
              ))}
              {showActionButton ? (
                <th
                  style={{
                    ...thStyle,
                    position: "sticky",
                    right: '-8px',
                    backgroundColor: "#627383",
                    zIndex: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingLeft: "30px",
                  }}
                >
                  Action{" "}
                  <input
                    style={{
                      padding: "0px",
                      margin: "0px",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                    checked={selectAll}
                    onChange={handleSelectAll}
                    type="checkbox"
                  />
                </th>
              ) : (
                ""
              )}
            </tr>
          </thead>
          <tbody>
            {allCategories?.length ? (
              allCategories.map((product, idx) => (
                <tr
                  key={product.Id}
                  className={idx % 2 === 0 ? style.evenRow : style.oddRow}
                >
                
                  {columns?.map((column) => (
                    <td key={column.key} style={tdStyle}>
                      {column?.key == "PlaneWeightByCategories" ? (
                        <div
                          className="weight-group"
                          style={{ marginRight: "2px" }}
                        >
                          {product?.StoneCategories?.split(",").map(
                            (item, Iindex) => (
                              <>
                                <div className="weight-boxL">{`${item} GM`}</div>
                                <div className="weight-boxR">
                                  {product.StonePieces.split(",")[Iindex]}
                                </div>
                              </>
                            )
                          )}
                        </div>
                      ) : (
                        <>
                          {column.type === "read"
                            ? column.calculate
                              ? column.calculate(product)
                              : column.label === "Customer"
                              ? `${product?.FirstName}`
                              : column.label === "S.No"?
                              `${(PageNumber -1 ) * PageSize + idx + 1}`
                              
                              : column.label === "Full Stone Less"
                              ? `${
                                  product[column.key] === "true" ? "YES" : "NO"
                                }`
                              : product[column.key]
                            : ""}
                        </>
                      )}
                    </td>
                  ))}
                  {showActionButton ? (
                    <td
                      style={{
                        ...tdStyle,
                        position: "sticky",
                        right: '-8px',
                        backgroundColor: "#fff",
                        zIndex: 2,
                      }}
                    >
                      <div className={style["action-container"]}>
                        <Icon
                          onClick={() => handleEditData(product)}
                          style={{ color: "#627282", cursor: "pointer" }}
                          icon="material-symbols-light:edit-outline"
                          width="20"
                          height="20"
                        />
                        {usedFor !== "rates" && (
                          <Icon
                            style={{ color: "#627282", cursor: "pointer" }}
                            icon="weui:delete-filled"
                            width="20"
                            height="20"
                          />
                        )}
                        <Icon
                          onClick={() => handlePrint(product)}
                          style={{ color: "#627282", cursor: "pointer" }}
                          icon="ic:outline-print"
                          width="20"
                          height="20"
                        />
                        <input
                          style={{
                            padding: "0px",
                            margin: "0px",
                            width: "20px",
                            height: "20px",
                          }}
                          checked={selectedItems.includes(product.Id)}
                          onChange={() => handleSelectItem(product.Id)}
                          type="checkbox"
                        />
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns?.length + 1} className={style?.tableCell}>
                  No Data
                </td>
              </tr>
            )}
          </tbody>
          {showSum && (
            <tfoot>
              {columns?.map((column) => (
                <th key={column.key} style={thStyle}>
                  {sum[column?.key]}
                </th>
              ))}
            </tfoot>
          )}
        </table>
      </div>

    
    </>
  );
}
